import { http, HttpResponse } from "msw";
import { apiUrl } from "@/mocks/utils";
import { makeTenant, makeMeUser } from "./auth.factory";

export const authHandlers = [
  http.get(apiUrl("v1/auth/tenants"), () => {
    return HttpResponse.json([makeTenant(), makeTenant(), makeTenant()]);
  }),

  http.post(apiUrl("v1/auth/select-tenant"), () => {
    return HttpResponse.json({ success: true });
  }),

  http.get(apiUrl("v1/auth/logout"), () => {
    return HttpResponse.json({ success: true });
  }),

  http.get(apiUrl("v1/user/me"), () => {
    return HttpResponse.json(makeMeUser());
  }),
];
